/*!
 * LEVERADE Widgets
 * Copyright miLeyenda Entertainment
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import i18n from './i18n'
import router from './router'
import './plugins/axios'
import './plugins/helpers'
import './plugins/iframe-resizer'
import './plugins/luxon'
import './plugins/qs'
import './plugins/store'
import './plugins/tinycolor'
import './plugins/uri'
import './plugins/vue-youtube'
import './modules/activities/ServiceProvider'

Vue.config.productionTip = false

/* eslint-disable no-new */

new Vue({
  el: '#app',
  i18n,
  router,
  render: (h) => h(App),
})



// WEBPACK FOOTER //
// ./src/server/main.js